const theme = {
    headerHeight: '70px',
    colors: {
        black: '#000000',
        white: '#ffffff',
        default: '#3f51b5',
    }

};

export default theme;